<template>
    <!-- Company Profileeeeesss -->
    <div class="page-layout blank contacts-manage">
        <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                  <div class="flex-container">
                      <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
                  </div>
            </div>
        </div>
        <div class="pb-10" v-if="!ajaxCallinprogress">
            <!-- <h2 class="headerblock"> -->
                <div class="row">
                    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                      <div class="breadcrumbnew">
                <!-- <a>Call Report</a>-->
                 <router-link to="/managecompany">List view</router-link>
                <span>Company Info</span>
            </div>
                    </div>
                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                        <!-- <div class="breadcome-heading d-none d-xl-inline">
                          <div class="form-group formsearch has-warning has-feedback">
                            <input type="text" class="form-control textremove holder" id="inputWarning2" aria-describedby="inputWarning2Status" placeholder="Search..."> -->
                            <!-- <span class="icon-close-circle-outline form-control-feedback-cancel" aria-hidden="true" ></span> -->
                            <!-- <span class="icon-magnify iconsearch form-control-feedback" aria-hidden="true"></span>
                          </div>
                        </div> -->
                        <!-- <router-link :disabled="!$routerHistory.hasForward()" :to="{ path: $routerHistory.next().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Forward" placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-right"></i>
                                </button>
                            </el-tooltip>
                        </router-link>
                        <router-link :disabled="!$routerHistory.hasPrevious()" :to="{ path: $routerHistory.previous().path }">
                            <el-tooltip class="item pull-right" effect="dark" content="Click to Go Back" placement="top">
                                <button class="btn btn-new-grey btn-fab-dc mr-3">
                                    <i class="icons icon-arrow-left"></i>
                                </button>
                            </el-tooltip>
                        </router-link> -->
                    </div>
                </div>
            <!-- </h2> -->
            <!-- <div class="profile-block"> -->
                <!-- <a href="javascript:;" class="btn btn-secondary btn-smm hidden-md-down" v-on:click="showAddEmployee()">
                    + Add New Contact
                </a> -->
                <!-- <div class="cover-pic" style="border-radius: 15px 15px 0px 0px;">
                    <img :src="userProfile" class="h-100 w-100" style="border-radius: 15px 15px 0px 0px;">
                    <div class="row align-items-center">
                        <img class="avatar huge coverPicIcon" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/dell.jpg" style="z-index: 1;border: 3px solid #c6dbf3;">
                    </div>
                </div> -->
                <div class="page-layout-new simple-new left-sidebar-block right-sidebar-block" style="border-radius: 15px;overflow: auto;">
                    <div class="left-side-div">
                        <div class="digi-sidebar-companyProfile digi-left-positioned digi-open digi-locked-open">
                            <div class="cover-card">
                                <img class="cover-card-img-top w-full" :src="companyData.cover_pic||userProfile" alt="Cover Pic" style="height: 180px;">
                                <div class="cover-card-block wall-person-info">
                                    <a class="person-avatar bg-white pro-img-bordered">
                                        <img class="companylogoimg" :src="companyData.logo||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/company-logo.png'" :alt="companyData.company_name">
                                    </a>
                                </div>
                            </div>
                            <div class="digi-content-block px-4 py-2 mt-10">
                                <div class="header pt-4">
                                    <div class="contactInfo">
                                        <div>
                                            <span class="text-white fw-600 fs-18 contactTitle">{{ companyData.company_name }}</span>
                                            <!-- <div class="mt-2 contactTitle">
                                                <img class="CompanyContact mr-1 mb-1" src="/static/images/crm/icons/phone-white.svg">
                                                <i class="crmnew-envelope mr-1 mb-1 text-white iconsize-16"></i>
                                                <span>
                                                    charlie@gmail.com
                                                </span>
                                            </div> -->
                                            <div class="mt-2 contactTitle fw-600">
                                              <!-- <img class="CompanyContact mr-1 mb-1" src="/static/images/crm/icons/earth-globe.svg"> -->
                                              <!-- <a :href="companyData.website" target="_blank" style="color: #fff;text-decoration: none;"> -->
                                                <i class="crmnew-earth-globe mr-1 mb-1 text-white iconsize-14"></i>
                                                <span>
                                                  {{ companyData.website }}
                                                </span>
                                              <!-- </a> -->
                                            </div>
                                            <div class="mt-2 contactTitle fw-600" v-if="companyData.primary_phone && companyData.primary_phone.phone_number">
                                              <!-- <img class="CompanyContact" src="/static/images/crm/icons/phone-white.svg"> -->
                                              <i class="crmnew-phone mr-1 mb-1 text-white iconsize-14"></i>
                                              <span>
                                                {{ companyData.primary_phone.phone_number }}
                                              </span>
                                            </div>
                                            <div class="widget widget6 card pt-3 pb-3 mt-5" style="display: none !important;box-shadow: none;border-radius: 10px;border: solid 0.5px #fff;background-image: linear-gradient(to right, #0086f8, #1c78f2 47%, #2d70ee);">
                                                <div class="widget-content">
                                                    <div class="row no-gutters">
                                                        <div class="col-4 d-flex flex-column align-items-center justify-content-center" style="cursor: pointer;">
                                                            <div class="count h2 text-white mb-2" style="line-height: 1.19;font-size: 16px;font-weight: 600;">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/connection_small.svg" alt="Connections" style="width: 14px;margin-right:4px;">
                                                                0
                                                            </div>
                                                            <div class="count-title text-white" style="line-height: 1.19;font-size: 12px;font-weight: 500;">Connections</div>
                                                        </div>
                                                        <div class="col-3 d-flex flex-column align-items-center justify-content-center">
                                                            <div class="count h2 text-white mb-2" style="line-height: 1.19;font-size: 16px;font-weight: 600;">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/followers_small.svg" alt="Followers" style="width: 13px;margin-right:4px;">
                                                                0
                                                            </div>
                                                            <div class="count-title text-white" style="line-height: 1.19;font-size: 12px;font-weight: 500;">Followers</div>
                                                        </div>
                                                        <div class="col-4 d-flex flex-column align-items-center justify-content-center ">
                                                            <div class="count h2 text-white mb-2" style="line-height: 1.19;font-size: 16px;font-weight: 600;">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/following_small.svg" alt="Following" style="width: 13px;margin-right:4px;">
                                                                0
                                                            </div>
                                                            <div class="count-title text-white" style="line-height: 1.19;font-size: 12px;font-weight: 500;">Following</div>
                                                        </div>
                                                        <div class="col-1 d-flex flex-column align-items-center justify-content-center">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/connection_router_arrow.svg" alt="Arrow" style="width: 10px;">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- <hr class="" style="border-top: 1px solid rgba(255, 255, 255, 1);margin-top: 25px;"> -->
                                            <!-- <div class="text-center mt-4 mb-3">
                                                <i class="icon icon-facebook text-white contactMediaView mediaFacebook" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                <i class="icon icon-twitter text-white contactMediaView mediaTwitter ml-2" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                                <i class="icon icon-skype text-white contactMediaView mediaSkype ml-2" style="font-size: 16px;width: 16px;height: 16px;line-height: 16px;"></i>
                                              </div>  -->
                                            <div class="mt-6 contactTitle" style="display:none">
                                                <div class="">
                                                    <a class="btn btn-success btn-smm text-white mx-4 mb-3 text-uppercase">Connect</a>
                                                    <a class="btn btn-danger btn-smm mx-4 mb-3 text-uppercase">Disconnect</a>
                                                    <a class="btn btn-warning btn-smm text-white mx-4 mb-3 text-uppercase">Follow</a>
                                                    <a class="btn btn-outline-white btn-smm mx-4 mb-3 text-uppercase">Pending</a>
                                                    <!-- <a class="btn btn-secondary btn-smm mx-4 mb-3 text-uppercase">Follow</!--> -->
                                                    <a class="btn btn-outline-white btn-smm mx-4 mb-3 text-uppercase">Unfollow</a>
                                                    <a class="btn btn-pink-new btn-smm mx-4 mb-3 text-uppercase">Invite</a>
                                                    <a class="btn btn-outline-white btn-smm mx-4 mb-3 text-uppercase">Invited</a>
                                                    <a class="btn btn-danger btn-smm mx-4 mb-3 text-uppercase">Terminate</a>
                                                </div>
                                            </div>
                                            <!-- <hr class="" style="border-top: 1px solid rgba(255, 255, 255, 0.2);">
                                              <h5 class="fs-14 pt-4 pb-3 text-center">Scan Code</h5>
                                              <div class="qrcode-block-view mt-3">
                                                  <img src="/static/images/qr-logo-dg.svg" class="qr-logo-view">
                                                  <qrcode-vue :value="valueqr" :size="size" level="H" background="#d6e2ef" foreground="#00448b" class="qrcode-content-view"></qrcode-vue>
                                              </div> -->
                                        </div>
                                        <!-- <hr style="border-top: 2px solid rgba(255, 255, 255, 0.5);" class="mt-3 mb-3"> -->

                                        <div class="px-6 mt-4" style="border-top: 1px solid #fff">
                                          <div class="widget widget6 card pt-3 pb-3 mt-5"
                                            style="box-shadow: none;border-radius: 10px;background-color: #29c2e0;">
                                            <div class="widget-content">
                                              <!-- @click="goToConnections" -->
                                              <div class="row no-gutters"  style="cursor: pointer;">
                                                <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center" style="border-bottom: 1px solid #1ca7e6;">
                                                  <div class="connectionbox" @click="$router.push({name: 'ConnectionList', params: {request_type: 'business',id: $route.params.id}})">
                                                    <div class="connection_pic">
                                                      <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/connection_small.svg"
                                                        alt="Connetions" />
                                                    </div>
                                                    <div class="connection_details">
                                                      <div class="count h2 text-white mb-1" style="line-height: 1.19;font-size: 16px;">
                                                        {{ connectionCount || 0 }}
                                                      </div>
                                                      <div class="count-title text-white"
                                                        style="line-height: 1.19;font-size: 14px;font-weight: 600;">Connections</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center" style="border-bottom: 1px solid #1ca7e6;">
                                                  <div class="connectionbox" @click="$router.push({name: 'FollowerList'})">
                                                    <div class="connection_pic">
                                                      <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/followers_small.svg"
                                                        alt="Followers"/>
                                                    </div>
                                                    <div class="connection_details">
                                                      <div class="count h2 text-white mb-1" style="line-height: 1.19;font-size: 16px;">
                                                        0
                                                      </div>
                                                      <div class="count-title text-white"
                                                        style="line-height: 1.19;font-size: 14px;font-weight: 600;">Followers</div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="col-12 py-3 d-flex flex-column align-items-center justify-content-center">
                                                  <div class="connectionbox" @click="$router.push({name: 'FollowingList'})">
                                                    <div class="connection_pic">
                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/following_small.svg"
                                                          alt="Following"/>
                                                    </div>
                                                    <div class="connection_details">
                                                      <div class="count h2 text-white mb-1" style="line-height: 1.19;font-size: 16px;">
                                                        0
                                                      </div>
                                                      <div class="count-title text-white"
                                                        style="line-height: 1.19;font-size: 14px;font-weight: 600;">Following</div>
                                                      </div>
                                                  </div>
                                                </div>

                                              </div>
                                            </div>
                                          </div>
                                          <div class="profile-list">
                                            <div class="profile-list-item" @click="changeModelView('companyInfoView')">

                                              <div class="profile-wrapper" v-bind:class="{ selected: companyInformation}">
                                                <img class="profile-images" alt="Info Image" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/info.svg">
                                              </div>
                                              <div class="profile-name">Info</div>
                                            </div>
                                            <div class="profile-list-item" @click="changeModelView('companyEmpView')">
                                              <div class="profile-wrapper" v-bind:class="{ selected: comapnyEmployees}">
                                                <img class="profile-images" alt="Employees" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/employees.svg">
                                              </div>
                                              <div class="profile-name">Employees</div>
                                            </div>
                                            <div v-if="account==$route.params.id" class="profile-list-item" @click="changeModelView('companyProView')">
                                              <div class="profile-wrapper" v-bind:class="{ selected: companyProducts}">
                                                <img class="profile-images" alt="Products" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/products.svg">
                                              </div>
                                              <div class="profile-name">Products</div>
                                            </div>
                                          </div>
                                          <div class="qrcode-block-view mt-6">
                                              <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/qr-logo-dg.svg" class="qr-logo-view">
                                              <qrcode-vue :value="valueqr" :size="size" level="H" background="#fff" foreground="#005dae" class="qrcode-content-view"></qrcode-vue>
                                          </div>
                                          <h5 class="fs-16 pt-4 pb-3 text-center text-white fw-600">Scan Code</h5>
                                        </div>
                                              <!-- </div> -->
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                   <!-- <div class="center-sc"> -->
                        <div class="center-section pr-1" style="border-radius: 15px; min-width: 50em;" v-if="companyInformation">
                          <div class="center-content">
                            <!-- <div class="infoHeader px-3 py-3" style="background: transparent;">
                              <div class="descriptionheader p-0"> -->
                                <!-- <div class="description-text-header-left">
                                  <h5 style="color: #303031;">
                                    Information Overview
                                  </h5>
                                </div> -->
                                <!-- <div class="description-text-header-right" v-if="account==$route.params.company_id && (admin || superAdmin)">
                                  <a href="javascript:;" class="btn btn-secondary btn-smm" v-on:click="editCompanyProfile()">
                                    <i class="icon-pencil pr-1" style="font-size: 16px;"></i>
                                    Edit
                                  </a>
                                </div> -->
                              <!-- </div>
                            </div> -->
                            <div class="preview-elements px-3 py-3">
                              <ul class="nav nav-tabs nav-fill nav-companyprofile" id="myTab" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active show mb-2" id="basic-tab" data-toggle="tab" href="#basictab" role="tab" aria-controls="basictab" aria-expanded="true" aria-selected="false">
                                    <!-- <img class="activityContact pr-2" src="/static/images/crm/icons/user.svg"> -->
                                    <i class="crmnew-user"></i>
                                    <h6>Basic Information</h6>
                                  </a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link mb-2" id="communication-tab" data-toggle="tab" href="#communicationtab" role="tab" aria-controls="communication" aria-selected="true">
                                    <!-- <img class="activityContact pr-2" src="/static/images/crm/icons/communication.svg"> -->
                                    <i class="crmnew-phone"></i>
                                    <h6>Communication</h6>
                                  </a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link mb-2" id="address-tab" href="#addresstab" role="tab" data-toggle="tab">
                                    <!-- <img class="activityContact pr-2" src="/static/images/crm/icons/marker.svg"> -->
                                    <i class="crmnew-marker defaultBlue"></i>
                                    <h6>Address</h6>
                                  </a>
                                </li>
                                <!-- <li class="nav-item">
                                                      <a class="nav-link" id="employees-tab" href="#employeestab" role="tab" data-toggle="tab" style="border-radius: 0px 12px 12px 0px;">
                                                          <i class="crmnew-employees"></i>
                                                          <h6>Employees</h6>
                                                      </a>
                                                  </li> -->
                              </ul>
                              <div v-if="account" class="tab-content profile-tab-content" id="myTabContent" style="max-height: 72em;">
                                <div class="tab-pane fade active show mt-3" id="basictab" role="tabpanel" aria-labelledby="basic-tab">
                                  <company-basic-info-view :companyData='companyData'></company-basic-info-view>
                                </div>
                                <div class="tab-pane fade mt-3" id="communicationtab" role="tabpanel" aria-labelledby="communication-tab">
                                  <company-communication-view :companyData='companyData'></company-communication-view>
                                </div>
                                <div class="tab-pane fade mt-3" id="addresstab" role="tabpanel" aria-labelledby="address-tab">
                                  <company-address-view :companyData='companyData'></company-address-view>
                                </div>
                                <!-- <div class="tab-pane fade mt-1" id="employeestab" role="tabpanel" aria-labelledby="employees-tab">
                                    <products-page></products-page>
                                </div> -->
                              </div>
                              <div v-else class="tab-content profile-tab-content" id="myTabContent" style="max-height: 62em;">
                                <div class="tab-pane fade active show mt-3" id="basictab" role="tabpanel" aria-labelledby="basic-tab">
                                  <company-basic-info-view :companyData='companyData'></company-basic-info-view>
                                </div>
                                <div class="tab-pane fade mt-3" id="communicationtab" role="tabpanel" aria-labelledby="communication-tab">
                                  <company-communication-view :companyData='companyData'></company-communication-view>
                                </div>
                                <div class="tab-pane fade mt-3" id="addresstab" role="tabpanel" aria-labelledby="address-tab">
                                  <company-address-view :companyData='companyData'></company-address-view>
                                </div>
                                <!-- <div class="tab-pane fade mt-1" id="employeestab" role="tabpanel" aria-labelledby="employees-tab">
                                    <products-page></products-page>
                                </div> -->
                              </div>
                            </div>
                          </div>
                        </div>
                    <!-- </div> -->
                    <div class="center-section pr-1" style="border-radius: 15px;min-width: 50em;" v-if="comapnyEmployees">
                      <div class="center-content">
                        <div class="preview-elements">
                          <EmployeeList></EmployeeList>
                        </div>
                      </div>
                    </div>
                    <div class="center-section pr-1" style="border-radius: 15px;min-width: 50em;" v-if="companyProducts">
                      <div class="center-content">
                        <div class="preview-elements px-4 py-6">
                          <products-page></products-page>
                        </div>
                      </div>
                    </div>
                  <!-- <div class="right-side-div px-4 py-2 mt-10">
                      <div class="digi-sidebar-companyProfile digi-right-positioned digi-open digi-locked-open">
                          <div class="digi-content-block">
                              Right
                          </div>
                      </div>
                  </div> -->
                </div>
                <!-- <add-employee modal_name="add-employee-modal"></add-employee> -->
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { company } from "./mixins/companySetup";
import { EventBus } from "./eventBus/nav-bar-event.js";
import CompanyBasicInfoView from "./CompanyBasicInfoView";
import CompanyCommunicationView from "./CompanyCommunicationView";
import CompanyAddressView from "./CompanyAddressView";
import EmployeeList from "./EmployeeList";
import ProductsPage from "./ProductsPage";
import myUpload from "vue-image-crop-upload";
// import AddEmployee from "./AddEmployee";
import SelectMap from "./SelectMap";
import ContactSuggestions from "./ContactSuggestions";
import VueVisible from 'vue-visible';
import { HalfCircleSpinner } from 'epic-spinners';
// import CompanyEmployees from "./CompanyEmployees";
export default {
  data() {
    return {
      size: 90,
       valueqr: "https://example.com",
      backToPrevious: true,
      toggleSideBar: false,
      contactTimeline: true,
      connectionCount: "",
      contactAbout: false,
      contactDeals: false,
      contactUpcomingEvents: false,
      show: false,
      userProfile:
        "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg",
      headers: {
        smail: "*_~",
      },
      contactActivity: "first",
      contactInfo: "first",
      account_id: "",
      companyInformation: false,
      comapnyEmployees: false,
      companyProducts: false,
      ajaxCallinprogress: false,
    };
  },
  mixins: [company],
  components: {
    CompanyBasicInfoView,
    CompanyCommunicationView,
    CompanyAddressView,
    EmployeeList,
    QrcodeVue,
    // PreferenceView,
    "my-upload": myUpload,
    //AddEmployee,
    SelectMap,
    ContactSuggestions,
    ProductsPage,
    VueVisible,
    HalfCircleSpinner
  },
  methods: {
    toggleBtn() {
      this.toggleSideBar = !this.toggleSideBar;
    },
    toggleBtn1() {
      this.toggleSideBar = false;
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(userProfile, field) {
      this.userProfile = userProfile;
    },
    cropUploadSuccess(jsonData, field) {},
    cropUploadFail(status, field) {},
    showEditMap() {
      this.$modal.show("edit_address_modal");
    },
    onUserBackground(e) {
      const file = e.target.files[0];
      this.userProfile = URL.createObjectURL(file);
    },
    // Edit Company Profile Redirection with Checking Router ID
    editCompanyProfile() {
      this.$router.push({
        name: "EditCompanyProfile",
        params: { id: this.$route.params.id },
      });
    },

    // CHange Tab View Function
    changeModelView(viewName) {
      switch (viewName) {
        case "companyInfoView":
          this.companyInformation = true;
          this.comapnyEmployees = false;
          this.companyProducts = false;

          break;
        case "companyEmpView":
          this.companyInformation = false;
          this.comapnyEmployees = true;
          this.companyProducts = false;
          break;
        case "companyProView":
          this.companyInformation = false;
          this.comapnyEmployees = false;
          this.companyProducts = true;
          break;
      }
    },
  },
  created() {
    this.GetCompanyData(this.$route.params.id);
    this.account_id = this.$route.params.id;
    if (localStorage.hasOwnProperty("backToEmployees")) {
      this.changeModelView("companyEmpView");
      localStorage.removeItem("backToEmployees");
    } else {
      this.changeModelView("companyInfoView");
    }
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    admin() {
      return this.$store.getters.isAdmin;
    },
    superAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  beforeRouteUpdate(to, from, next) {
    const id = to.params.id;
    this.GetCompanyData(id);
    this.account_id = id;
    next();
  },

};
</script>
<style>
.profile-block {
  /* border: 1px solid #e0e3e6; */
  border-radius: 15px;
  /* margin: 15px 15px 30px; */
  width: 100%;
  /* background: #eaeaec; */
}
.page-layout-new {
  position: relative;
  overflow: hidden;
}
.page-layout-new.simple-new {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-flex: 1;
  flex: 1 0 auto;
  width: 100%;
  min-width: 100%;
  border-radius: 0px 0px 15px 15px;
  color: #fff;
  /* border: #00448b; */
}
/* background-image: linear-gradient(180deg,#eaeaec,#f7f7f8 15%,#f7f7f8 34%,#fff 48%,#f7f7f8 62%,#f7f7f8 85%,hsla(240,5%,92%,.8)); */
.page-layout-new.simple-new.left-sidebar-block,
.page-layout-new.simple-new.right-sidebar-block {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}
.page-layout-new.simple-new.left-sidebar-block > .left-side-div,
.page-layout-new.simple-new.right-sidebar-block > .right-side-div {
  background: 0 0;
  box-shadow: none;
  background: #bed1f8;

}
.page-layout-new.simple-new.left-sidebar-block > .digi-sidebar-companyProfile,
.page-layout-new.simple-new.right-sidebar-block > .digi-sidebar-companyProfile {
  width: 240px;
  min-width: 240px;
  max-width: 240px;
  overflow: hidden;
}
.page-layout-new.simple-new.right-sidebar-block > .digi-sidebar-companyProfile {
  -webkit-box-ordinal-group: 3;
  order: 2;
}
.digi-sidebar-companyProfile {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-flex: 1;
  flex: 1 0 auto;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 0px 10px 0px 0px!important;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 388px !important;
  min-width: 388px !important;
  max-width: 388px !important;
  left: 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    margin: 10px;
    border: solid 0.5px #005dae;
    background-image: linear-gradient(to bottom, #005dae, #29c2e0);
    border-radius: 15px;
}

.digi-sidebar-companyProfile.digi-left-positioned {
   left: 0;
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    /* margin: 10px; */
    border: solid 0.5px #005dae;
    background-image: linear-gradient(to bottom, #005dae, #29c2e0);
    border-radius: 15px;
}
.digi-sidebar-companyProfile.digi-right-positioned {
  right: 0;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}
.digi-sidebar-companyProfile.digi-open {
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
.digi-sidebar-companyProfile.digi-locked-open {
  position: relative !important;
  -webkit-transform: translateX(0) !important;
  transform: translateX(0) !important;
}
.page-layout-new.simple-new.left-sidebar-block
  > .digi-sidebar-companyProfile
  .digi-content-block,
.page-layout-new.simple-new.right-sidebar-block
  > .digi-sidebar-companyProfile
  .digi-content-block {
  -webkit-box-flex: 1;
  flex: 1 1 auto;
}
.page-layout-new.simple-new.left-sidebar-block > .center-section,
.page-layout-new.simple-new.right-sidebar-block > .center-section {
  position: relative;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  z-index: 3;
  min-width: 0;
  width: 100%;
  border-radius: 15px;
    /* padding-left: 6px; */
  border: 3px solid #0D84EC;
  background: #ecf1f9;
}
.page-layout-new.simple-new.left-sidebar-block
  > .digi-sidebar-companyProfile.digi-locked-open
  + .center-section,
.page-layout-new.simple-new.right-sidebar-block
  > .digi-sidebar-companyProfile.digi-locked-open
  + .center-section {
  z-index: 1001;
}
.page-layout-new.simple-new.left-sidebar-block
  > .digi-sidebar-companyProfile.digi-locked-open.digi-left-positioned
  + .center-section,
.page-layout-new.simple-new.right-sidebar-block
  > .digi-sidebar-companyProfile.digi-locked-open.digi-left-positioned
  + .center-section {
  margin-left: 0;
}
.page-layout-new.simple-new.left-sidebar-block
  > .center-section
  > .center-content,
.page-layout-new.simple-new.right-sidebar-block
  > .center-section
  > .center-content {
    background: transparent;
    border-radius: 15px 15px 15px 15px;
}
.page-layout-new.simple-new.left-sidebar-block
  > .center-section
  > .center-content,
.page-layout-new.simple-new.right-sidebar-block
  > .center-section
  > .center-content {
  -webkit-box-flex: 1;
  flex: 1 0 auto;
  color: #303031;
}

@-moz-document url-prefix() {
  .coverPicIcon {
    margin-top: 123px;
  }

  .mediaIcon {
    top: 19% !important;
  }
}

.contactInfo {
  margin-top: 10px;
  display: block;
  justify-content: center;
  align-items: center;
  margin-bottom: 3%;
  position: relative;
  color: #00448b;
}

.companyBackground {
  border-right: solid 1px #94bef0;
  background-image: linear-gradient(
    to bottom,
    #eaeaec,
    #f7f7f8 15%,
    #ffffff 34%,
    #ffffff 48%,
    #ffffff 62%,
    #f7f7f8 85%,
    rgba(234, 234, 236, 0.8)
  );
}

.CompanyContact {
  width: 14.2px;
  height: 10.8px;
}

.headerTitleView {
  width: 357px;
  height: 40px;
  border-radius: 100px;
  background-color: #f2f2f2;
  margin-top: 15px;
  display: inline-block;
}

.contactActiveTab {
  color: #00448b !important;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  border-right: solid 18px #cdd2da;
  background-color: #f1f1f1;
  border-right-color: #ffffff;
  overflow: inherit !important;
  padding-left: 45px !important;
}

.info:hover {
  color: #00448b;
}

.info {
  margin-right: 40px;
}

.a-q-Jc-Pj-Ya-contactView {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  line-height: 30px;
}
.a-q-Jc-Pj-Ya-contactView {
  line-height: 25px;
  padding: 0px 10px 5px 3px;
}

.a-q-Jc-Lb-contactView {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-flex: 1 1 auto;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  text-decoration: none;
  line-height: 1.21;
  letter-spacing: normal;
  color: #303031;
  margin-left: 88px;
  padding: 16px 10px 16px 3px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.16);
}

.a-q-Jc-Pj-Ya-contactView:nth-of-type(even) {
  background-color: #f5f6f9;
}

.a-q-Jc-Lb-contactView.linkactive {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: right;
  color: #00448b;
}

.a-q-Jc-wg-contactView {
  text-decoration: none;
}

.suggestionCompany {
  width: 48px;
  height: 48px;
}

@media screen and (max-width: 991px) {
  .suggestions {
    display: none !important;
  }
}

@media screen and (max-width: 764px) {
  .companyDisplay {
    display: none !important;
  }
}

.textWhite {
  color: white;
}

.contactMediaView {
  font-size: 18px !important;
  padding-top: 3px !important;
  cursor: pointer;
  padding-left: 3px;
}

.mediaFacebook:hover {
  color: RGB(0, 132, 255) !important;
}

.mediaTwitter:hover {
  color: #1da1f2 !important;
}

.mediaLinkedIn:hover {
  color: #0077b5 !important;
}

.mediaSkype:hover {
  color: #0077b5 !important;
}

.verticalTab {
  height: 41px;
  display: flex;
  width: 100%;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 24px;
  position: relative;
  justify-content: center;
}

.contactSidebar {
  overflow-x: hidden;
  width: 312.7px;
  /* border-right: solid 1px #cdd2da; */
  background-image: linear-gradient(
    to bottom,
    #eaeaec,
    #f7f7f8 15%,
    #ffffff 34%,
    #ffffff 48%,
    #ffffff 62%,
    #f7f7f8 85%,
    rgba(234, 234, 236, 0.8)
  );
}

.contactTitle {
  text-align: center;
  display: block;
  color: #fff;
}

.elTab {
  overflow-x: hidden !important;
}

.editProfile {
  float: right;
  right: 25px;
  top: 135px;
  position: absolute;
  color: #ffffff;
  border-radius: 50px;
  width: 112.5px;
  height: 33.2px;
  border: solid 1px rgba(0, 0, 0, 0.4);
  background-color: rgba(0, 0, 0, 0.2);
}

.activityContact {
  width: 35px;
  height: 20px;
}

.contact-details-tab-view.el-tabs--border-card > .el-tabs__header {
  background-color: #fff !important;
  border-right: none !important;
  color: #00448b;
}

.contact-details-tab-view
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item.is-active {
  border-right-color: #ffffff !important;
  border-left-color: #ffffff !important;
  border-bottom-color: #00448b;
}

.contact-details-tab-view
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item {
  color: #00448b !important;
}

.contact-details-tab-view .el-tabs__item {
  color: #303031 !important;
}

.el-main.contactTabs {
  padding-top: 0px !important;
  padding-left: 6px !important;
  margin-left: -2px;
  border-left: solid 1px #cdd2da;
  padding-right: 20px !important;
  padding-bottom: 20px !important;
}

.email-ul.dc-menu--horizontal {
  height: 42px;
  background-color: #f5f6f9;
}

.email-ul.dc-menu--horizontal > .dc-menu-item {
  height: 42px !important;
  line-height: 42px !important;
  margin: 0;
}

.email-ul .nav-link {
  height: 42px !important;
  /* background-color: #f5f6f9; */
}

.email-ul .nav-link:hover {
  background-color: none !important;
}

.email-inputs {
  padding-left: 100px;
  padding-right: 100px;
}

.aboutHeading {
  display: flex;
  width: 100%;
  padding-top: 8px;
  padding-left: 22px;
}
input[type="file"] {
  display: none;
}
.el-main.contactTabs {
  padding-top: 0px !important;
  padding-left: 6px !important;
  margin-left: -2px;
  border-left: solid 1px #cdd2da;
  padding-right: 20px !important;
  padding-bottom: 20px !important;
}
.contactSidebar {
  border-right: 0px solid #94b3f0 !important;
}

.qrcode-block-view {
  border-radius: 6px;
  width: 104px;
  height: 105px;
  position: relative;
  display: inline-block;
  display: block;
  border: 1px solid #00448b;
  background: #d6e2ef;
}
.qrcode-content-view {
  text-align: center;
  margin: 6px auto;
  background: #d6e2ef !important;
}
.qr-logo-view {
  position: absolute;
  margin-top: 40px;
  margin-left: 35px;
  width: 30px;
}
.contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__header {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 15px 5px 5px !important;
}
.contact-details-tab-view.el-tabs.el-tabs--top .el-tabs__content {
  top: 10px;
}

.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-firstblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-secondblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav
  .el-tabs__active-bar {
  height: 3px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav-scroll {
  padding: 0 8px !important;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__header.is-top
  .el-tabs__nav-wrap
  .el-tabs__nav
  .el-tabs__item {
  padding: 2px 20px;
  height: 45px;
  line-height: 45px;
}

.nav-tabs.nav-companyprofile .nav-link.active, .nav-tabs.nav-companyprofile .nav-item.show .nav-link {
    color: #00448b;
    background-color: transparent;
}
.nav-tabs.nav-companyprofile .nav-link.active:not(.dropdown-toggle):after,
.nav-tabs.nav-companyprofile .nav-item.show .nav-link:not(.dropdown-toggle):after {
    background-color: transparent !important;
    content: none !important;
}
.nav.nav-tabs.nav-companyprofile {
    background: transparent;
    border-radius: 0px 0px 0px 0px;
    padding-bottom: 15px;
    border-bottom: 1px solid #707070;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    overflow-x: auto;
    max-height: 6em;
}
.nav-tabs.nav-companyprofile .nav-link.active {
    overflow: visible;
}
.nav-tabs.nav-companyprofile .nav-link:hover,
.nav-tabs.nav-companyprofile .nav-link:focus {
    border-color: #00448b;
    background-color: #00448b;
    color: #fff !important;
}

.nav-tabs.nav-companyprofile .nav-link {
    border: 1px solid #4e5764;
    position: relative;
    display: block;
    height: 48px !important;
    margin-right: 10px;
    line-height: 48px;
    border-radius: 12px;
    margin-right: 10px;
    color: #4e5764
}
.nav-tabs.nav-companyprofile .nav-link.active,
.nav-tabs.nav-companyprofile .nav-item.show .nav-link {
    border-color: #00448b;
    background-color: #00448b;
    color: #fff;
}
.nav-tabs.nav-companyprofile .nav-link img {
    display: inline-block;
    text-align: center;
    margin: 8px auto 6px;
}
.nav-tabs.nav-companyprofile .nav-link i {
    display: inline-block;
    text-align: center;
    margin: 12px auto 6px;
    font-size: 16px !important;
    width: 42px;
    height: 14px;
    line-height: 14px;
    color: #4e5764;
}

.nav-tabs.nav-companyprofile .nav-link.active i,
.nav-tabs.nav-companyprofile .nav-item.show .nav-link i {
    color: #fff !important;
}
.nav-tabs.nav-companyprofile .nav-link:hover i,
.nav-tabs.nav-companyprofile .nav-link:focus i {
    color: #fff;
}
.nav-tabs.nav-companyprofile .nav-link h6 {
    display: inline-block;
    font-size: 14px;
    text-align: center;
    font-weight: 600;
    color: #303031;
}
.nav-tabs.nav-companyprofile .nav-link.active h6,
.nav-tabs.nav-companyprofile .nav-item.show .nav-link h6 {
    color: #fff;
}
.nav-tabs.nav-companyprofile .nav-link:hover h6,
.nav-tabs.nav-companyprofile .nav-link:focus h6 {
    color: #fff;
}
.tab-content.profile-tab-content {
  padding: 10px 0px;
  overflow-y: auto;
  overflow-x: hidden;
}
.tabs.tabs-style-iconbox {
  position: relative;
  margin: 0 auto;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
}
.tabs.tabs-style-iconbox {
  background: rgba(255, 255, 255, 0.4);
}
.tabs.tabs-style-iconbox {
  text-align: center;
}
.tabs.tabs-style-iconbox {
  position: relative;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: flex;
  margin: 0 auto;
  padding: 0;
  max-width: 1200px;
  list-style: none;
  -ms-box-orient: horizontal;
  -ms-box-pack: center;
  -webkit-flex-flow: row wrap;
  -moz-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  justify-content: center;
}
.tabs.tabs-style-iconbox li {
  position: relative;
  z-index: 1;
  display: block;
  margin: 0;
  text-align: center;
  -webkit-flex: 1;
  -moz-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.tabs.tabs-style-iconbox li.tab-current {
  z-index: 100;
}
.tabs.tabs-style-iconbox a {
  position: relative;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 2.5;
  text-decoration: none;
  outline: none;
  width: 100%;
}
.tabs.tabs-style-iconbox li a {
  overflow: visible;
  padding: 2em 0;
  line-height: 1;
  -webkit-transition: color 0.2s;
  transition: color 0.2s;
}
.tabs.tabs-style-iconbox li.tab-current a {
  color: #74777b;
}
.tabs.tabs-style-iconbox li.tab-current a {
  background: #fff;
  box-shadow: -1px 0 0 #fff;
}
.tabs.tabs-style-iconbox .icon::before {
  display: block;
  margin: 0 0 0.25em 0;
}
.tabs.tabs-style-iconbox a span {
  vertical-align: middle;
  font-size: 0.75em;
}
.tabs.tabs-style-iconbox li a span {
  font-weight: 700;
  font-size: 0.7em;
}
.tabs.tabs-style-iconbox li.tab-current a::after,
.nav-tabs .nav-link.active:not(.dropdown-toggle):after,
.nav-tabs .nav-item.show .nav-link:not(.dropdown-toggle):after {
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -10px;
  width: 0;
  height: 0;
  border: solid transparent;
  border-width: 10px;
  border-top-color: #00448b;
  content: "";
  pointer-events: none;
  background-color: transparent !important;
}
.cover-card {
  position: relative;
  display: block;
  min-width: 0;
  background-color: transparent;
  -webkit-background-clip: border-box;
  background-clip: border-box;
  border: 1px solid transparent;
  border-radius: 0rem;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  height: 150px;
}
.cover-card {
  margin-bottom: 2.143rem;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.cover-card-img-top {
  width: 100%;
  border-radius: 15px;
  vertical-align: middle;
  border-style: none;
}
.cover-card-block.wall-person-info {
  position: relative;
  padding: 1.429rem 0rem 0rem 0rem;
  -webkit-box-flex: 1;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  text-align: center;
}
.wall-person-info .person-avatar {
  position: relative;
  top: -70px;
  width: 110px;
  height: 110px;
  text-align: center;
  display: inline-block;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 1000px;
}
.pro-img-bordered {
  padding: 3px;
  border: 1px solid #e0e0e0;
}
/* .person-avatar img {
  width: 100%;
  max-width: 100%;
  height: auto;
  border: 0 none;
  border-radius: 1000px;
  margin: 0px auto;
} */
.person-avatar .companylogoimg {
  width: 102px;
  max-width: 102px;
  height: 102px;
  border: 0 none;
  border-radius: 1000px;
  margin: 0px auto;
}

.profile-list {
  flex-flow: row wrap;
  box-sizing: border-box;
  display: flex;
  place-content: start;
  align-items: center;
  flex: 0 0 auto;
  padding: 15px 0;
  max-height: none !important;
}
.profile-list-item {
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: center;
  min-width: 120px;
  min-height: 120px;
  width: 120px;
  height: 120px;
  padding: 10px 0;
  margin: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}
.profile-list-item .profile-wrapper {
  font-size: 100px !important;
  width: 100px !important;
  height: 100px !important;
  min-width: 100px !important;
  min-height: 100px !important;
  line-height: 70px !important;
  text-align: center;
}
.profile-list-item img.profile-images {
  font-size: 85px !important;
  width: 85px !important;
  height: 85px !important;
  min-width: 85px !important;
  min-height: 85px !important;
  line-height: 85px !important;
  display: inline-block;
  margin: 7px auto;
}
.profile-name {
  padding: 8px 5px 0;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #fff;
}
  .connectionbox {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0;
    margin: 0;
  }
  .connection_pic {
    padding-right: 1rem;
  }
  .connection_pic img {
    width: 25px;
    height: 25px;
  }
  .connection_details {
    line-height: 0;
    text-align: center;
  }
  .connection_details .count {
    display: block;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.5rem;
    -webkit-transition: color .3s ease;
    transition: color .3s ease;
    color: #fff;
  }
  .connection_details .count-title {
    width: 100px;
    margin-top: 1px;
    display: inline-block;
    font-size: 14px;
    line-height: 1rem;
    font-weight: 600;
    color: #fff;
}
.qrcode-block-view {
    border-radius: 6px;
    width: 104px;
    height: 105px;
    position: relative;
    display: block;
    border: 1px solid #005dae;
    background: #fff;
    margin: 0 auto;
  }
.qr-logo-view {
    position: absolute;
    margin-top: 40px;
    margin-left: 35px;
    width: 30px;
  }

</style>


// WEBPACK FOOTER //
// src/components/CompanyProfile.vue